import { useEffect } from 'react'
import { values } from 'ramda'

import FiltersPlainLayout, { Column } from 'app/common/layouts/FiltersPlainLayout'
import { FilterItem, useFilterData } from 'app/common/ui-components/filter'
import filterBuilding from 'app/components/common/reports/filters/building'
import { VisuallyHiding } from 'app/components/common/reports/VisuallyHiding'


type Props = {
  loading: boolean,
  foodModeEnable: boolean,
}

const FilterWindow = ({ loading, foodModeEnable }: Props) => {
  const [, state, , { filtersLoad, resetAll, applyFilters }] = useFilterData()
  const buildingItems = values(state[filterBuilding].items)

  useEffect(() => {
    filtersLoad()
  }, [filtersLoad])


  return (
    <FiltersPlainLayout
      loading={loading}
      onApplyFilter={applyFilters}
      onResetAll={resetAll}
    >
      <Column>
        <FilterItem filterId="year" />
        <FilterItem filterId="period" />
        <FilterItem filterId="detailsGroup" />
      </Column>
      <Column>
        {foodModeEnable
          && <FilterItem filterId="foodMode" />}
        <FilterItem filterId="class" />
        <VisuallyHiding hiding={buildingItems.length <= 1}>
          <FilterItem filterId={filterBuilding} />
        </VisuallyHiding>
      </Column>
      <Column>
        <FilterItem filterId="status" />
      </Column>
    </FiltersPlainLayout>
  )
}

export default FilterWindow
